var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.odds)?_c('div',{staticClass:"correct-score-odds",class:[_vm.valueClass],on:{"click":function($event){return _vm.placeBet($event.target)}}},[_vm._v(_vm._s(_vm.value))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }